"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ɵngcc0 = require('@angular/core');
var AgGridColumn = /** @class */ (function () {
    function AgGridColumn() {
    }
    AgGridColumn.prototype.hasChildColumns = function () {
        if (this.childColumns && this.childColumns.length > 0) {
            // necessary because of https://github.com/angular/angular/issues/10098
            return !(this.childColumns.length === 1 && this.childColumns.first === this);
        }
        return false;
    };
    AgGridColumn.prototype.toColDef = function () {
        var colDef = this.createColDefFromGridColumn(this);
        if (this.hasChildColumns()) {
            colDef["children"] = this.getChildColDefs(this.childColumns);
        }
        return colDef;
    };
    AgGridColumn.prototype.getChildColDefs = function (childColumns) {
        return childColumns
            // necessary because of https://github.com/angular/angular/issues/10098
            .filter(function (column) { return !column.hasChildColumns(); })
            .map(function (column) {
            return column.toColDef();
        });
    };
    ;
    AgGridColumn.prototype.createColDefFromGridColumn = function (from) {
        var colDef = {};
        Object.assign(colDef, from);
        delete colDef.childColumns;
        return colDef;
    };
    ;
    /** @nocollapse */
    AgGridColumn.ctorParameters = function () { return []; };
    AgGridColumn.propDecorators = {
        'childColumns': [{ type: core_1.ContentChildren, args: [AgGridColumn,] },],
        'children': [{ type: core_1.Input },],
        'sortingOrder': [{ type: core_1.Input },],
        'allowedAggFuncs': [{ type: core_1.Input },],
        'menuTabs': [{ type: core_1.Input },],
        'cellClassRules': [{ type: core_1.Input },],
        'icons': [{ type: core_1.Input },],
        'headerGroupComponent': [{ type: core_1.Input },],
        'headerGroupComponentFramework': [{ type: core_1.Input },],
        'headerGroupComponentParams': [{ type: core_1.Input },],
        'cellStyle': [{ type: core_1.Input },],
        'cellRendererParams': [{ type: core_1.Input },],
        'cellEditorFramework': [{ type: core_1.Input },],
        'cellEditorParams': [{ type: core_1.Input },],
        'pinnedRowCellRendererFramework': [{ type: core_1.Input },],
        'pinnedRowCellRendererParams': [{ type: core_1.Input },],
        'filterFramework': [{ type: core_1.Input },],
        'filterParams': [{ type: core_1.Input },],
        'headerComponent': [{ type: core_1.Input },],
        'headerComponentFramework': [{ type: core_1.Input },],
        'headerComponentParams': [{ type: core_1.Input },],
        'floatingFilterComponent': [{ type: core_1.Input },],
        'floatingFilterComponentParams': [{ type: core_1.Input },],
        'floatingFilterComponentFramework': [{ type: core_1.Input },],
        'tooltipComponent': [{ type: core_1.Input },],
        'tooltipComponentParams': [{ type: core_1.Input },],
        'tooltipComponentFramework': [{ type: core_1.Input },],
        'refData': [{ type: core_1.Input },],
        'headerName': [{ type: core_1.Input },],
        'columnGroupShow': [{ type: core_1.Input },],
        'headerClass': [{ type: core_1.Input },],
        'toolPanelClass': [{ type: core_1.Input },],
        'headerValueGetter': [{ type: core_1.Input },],
        'groupId': [{ type: core_1.Input },],
        'colId': [{ type: core_1.Input },],
        'sort': [{ type: core_1.Input },],
        'field': [{ type: core_1.Input },],
        'type': [{ type: core_1.Input },],
        'tooltipField': [{ type: core_1.Input },],
        'headerTooltip': [{ type: core_1.Input },],
        'cellClass': [{ type: core_1.Input },],
        'showRowGroup': [{ type: core_1.Input },],
        'filter': [{ type: core_1.Input },],
        'aggFunc': [{ type: core_1.Input },],
        'cellRenderer': [{ type: core_1.Input },],
        'cellEditor': [{ type: core_1.Input },],
        'pinned': [{ type: core_1.Input },],
        'chartDataType': [{ type: core_1.Input },],
        'sortedAt': [{ type: core_1.Input },],
        'flex': [{ type: core_1.Input },],
        'width': [{ type: core_1.Input },],
        'minWidth': [{ type: core_1.Input },],
        'maxWidth': [{ type: core_1.Input },],
        'rowGroupIndex': [{ type: core_1.Input },],
        'pivotIndex': [{ type: core_1.Input },],
        'dndSourceOnRowDrag': [{ type: core_1.Input },],
        'valueGetter': [{ type: core_1.Input },],
        'valueSetter': [{ type: core_1.Input },],
        'filterValueGetter': [{ type: core_1.Input },],
        'keyCreator': [{ type: core_1.Input },],
        'cellRendererFramework': [{ type: core_1.Input },],
        'pinnedRowCellRenderer': [{ type: core_1.Input },],
        'valueFormatter': [{ type: core_1.Input },],
        'pinnedRowValueFormatter': [{ type: core_1.Input },],
        'valueParser': [{ type: core_1.Input },],
        'comparator': [{ type: core_1.Input },],
        'equals': [{ type: core_1.Input },],
        'pivotComparator': [{ type: core_1.Input },],
        'suppressKeyboardEvent': [{ type: core_1.Input },],
        'colSpan': [{ type: core_1.Input },],
        'rowSpan': [{ type: core_1.Input },],
        'getQuickFilterText': [{ type: core_1.Input },],
        'newValueHandler': [{ type: core_1.Input },],
        'onCellValueChanged': [{ type: core_1.Input },],
        'onCellClicked': [{ type: core_1.Input },],
        'onCellDoubleClicked': [{ type: core_1.Input },],
        'onCellContextMenu': [{ type: core_1.Input },],
        'tooltip': [{ type: core_1.Input },],
        'tooltipValueGetter': [{ type: core_1.Input },],
        'cellRendererSelector': [{ type: core_1.Input },],
        'cellEditorSelector': [{ type: core_1.Input },],
        'suppressCellFlash': [{ type: core_1.Input },],
        'suppressColumnsToolPanel': [{ type: core_1.Input },],
        'suppressFiltersToolPanel': [{ type: core_1.Input },],
        'openByDefault': [{ type: core_1.Input },],
        'marryChildren': [{ type: core_1.Input },],
        'hide': [{ type: core_1.Input },],
        'rowGroup': [{ type: core_1.Input },],
        'pivot': [{ type: core_1.Input },],
        'checkboxSelection': [{ type: core_1.Input },],
        'headerCheckboxSelection': [{ type: core_1.Input },],
        'headerCheckboxSelectionFilteredOnly': [{ type: core_1.Input },],
        'suppressMenu': [{ type: core_1.Input },],
        'suppressSorting': [{ type: core_1.Input },],
        'suppressMovable': [{ type: core_1.Input },],
        'suppressFilter': [{ type: core_1.Input },],
        'lockPosition': [{ type: core_1.Input },],
        'lockVisible': [{ type: core_1.Input },],
        'lockPinned': [{ type: core_1.Input },],
        'unSortIcon': [{ type: core_1.Input },],
        'suppressSizeToFit': [{ type: core_1.Input },],
        'suppressResize': [{ type: core_1.Input },],
        'suppressAutoSize': [{ type: core_1.Input },],
        'enableRowGroup': [{ type: core_1.Input },],
        'enablePivot': [{ type: core_1.Input },],
        'enableValue': [{ type: core_1.Input },],
        'editable': [{ type: core_1.Input },],
        'suppressPaste': [{ type: core_1.Input },],
        'suppressNavigable': [{ type: core_1.Input },],
        'enableCellChangeFlash': [{ type: core_1.Input },],
        'rowDrag': [{ type: core_1.Input },],
        'dndSource': [{ type: core_1.Input },],
        'autoHeight': [{ type: core_1.Input },],
        'sortable': [{ type: core_1.Input },],
        'resizable': [{ type: core_1.Input },],
        'singleClickEdit': [{ type: core_1.Input },],
    };
AgGridColumn.ɵfac = function AgGridColumn_Factory(t) { return new (t || AgGridColumn)(); };
AgGridColumn.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AgGridColumn, selectors: [["ag-grid-column"]], contentQueries: function AgGridColumn_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, AgGridColumn, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.childColumns = _t);
    } }, inputs: { children: "children", sortingOrder: "sortingOrder", allowedAggFuncs: "allowedAggFuncs", menuTabs: "menuTabs", cellClassRules: "cellClassRules", icons: "icons", headerGroupComponent: "headerGroupComponent", headerGroupComponentFramework: "headerGroupComponentFramework", headerGroupComponentParams: "headerGroupComponentParams", cellStyle: "cellStyle", cellRendererParams: "cellRendererParams", cellEditorFramework: "cellEditorFramework", cellEditorParams: "cellEditorParams", pinnedRowCellRendererFramework: "pinnedRowCellRendererFramework", pinnedRowCellRendererParams: "pinnedRowCellRendererParams", filterFramework: "filterFramework", filterParams: "filterParams", headerComponent: "headerComponent", headerComponentFramework: "headerComponentFramework", headerComponentParams: "headerComponentParams", floatingFilterComponent: "floatingFilterComponent", floatingFilterComponentParams: "floatingFilterComponentParams", floatingFilterComponentFramework: "floatingFilterComponentFramework", tooltipComponent: "tooltipComponent", tooltipComponentParams: "tooltipComponentParams", tooltipComponentFramework: "tooltipComponentFramework", refData: "refData", headerName: "headerName", columnGroupShow: "columnGroupShow", headerClass: "headerClass", toolPanelClass: "toolPanelClass", headerValueGetter: "headerValueGetter", groupId: "groupId", colId: "colId", sort: "sort", field: "field", type: "type", tooltipField: "tooltipField", headerTooltip: "headerTooltip", cellClass: "cellClass", showRowGroup: "showRowGroup", filter: "filter", aggFunc: "aggFunc", cellRenderer: "cellRenderer", cellEditor: "cellEditor", pinned: "pinned", chartDataType: "chartDataType", sortedAt: "sortedAt", flex: "flex", width: "width", minWidth: "minWidth", maxWidth: "maxWidth", rowGroupIndex: "rowGroupIndex", pivotIndex: "pivotIndex", dndSourceOnRowDrag: "dndSourceOnRowDrag", valueGetter: "valueGetter", valueSetter: "valueSetter", filterValueGetter: "filterValueGetter", keyCreator: "keyCreator", cellRendererFramework: "cellRendererFramework", pinnedRowCellRenderer: "pinnedRowCellRenderer", valueFormatter: "valueFormatter", pinnedRowValueFormatter: "pinnedRowValueFormatter", valueParser: "valueParser", comparator: "comparator", equals: "equals", pivotComparator: "pivotComparator", suppressKeyboardEvent: "suppressKeyboardEvent", colSpan: "colSpan", rowSpan: "rowSpan", getQuickFilterText: "getQuickFilterText", newValueHandler: "newValueHandler", onCellValueChanged: "onCellValueChanged", onCellClicked: "onCellClicked", onCellDoubleClicked: "onCellDoubleClicked", onCellContextMenu: "onCellContextMenu", tooltip: "tooltip", tooltipValueGetter: "tooltipValueGetter", cellRendererSelector: "cellRendererSelector", cellEditorSelector: "cellEditorSelector", suppressCellFlash: "suppressCellFlash", suppressColumnsToolPanel: "suppressColumnsToolPanel", suppressFiltersToolPanel: "suppressFiltersToolPanel", openByDefault: "openByDefault", marryChildren: "marryChildren", hide: "hide", rowGroup: "rowGroup", pivot: "pivot", checkboxSelection: "checkboxSelection", headerCheckboxSelection: "headerCheckboxSelection", headerCheckboxSelectionFilteredOnly: "headerCheckboxSelectionFilteredOnly", suppressMenu: "suppressMenu", suppressSorting: "suppressSorting", suppressMovable: "suppressMovable", suppressFilter: "suppressFilter", lockPosition: "lockPosition", lockVisible: "lockVisible", lockPinned: "lockPinned", unSortIcon: "unSortIcon", suppressSizeToFit: "suppressSizeToFit", suppressResize: "suppressResize", suppressAutoSize: "suppressAutoSize", enableRowGroup: "enableRowGroup", enablePivot: "enablePivot", enableValue: "enableValue", editable: "editable", suppressPaste: "suppressPaste", suppressNavigable: "suppressNavigable", enableCellChangeFlash: "enableCellChangeFlash", rowDrag: "rowDrag", dndSource: "dndSource", autoHeight: "autoHeight", sortable: "sortable", resizable: "resizable", singleClickEdit: "singleClickEdit" }, decls: 0, vars: 0, template: function AgGridColumn_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AgGridColumn, [{
        type: core_1.Component,
        args: [{
                selector: 'ag-grid-column',
                template: ''
            }]
    }], function () { return []; }, { childColumns: [{
            type: core_1.ContentChildren,
            args: [AgGridColumn]
        }], children: [{
            type: core_1.Input
        }], sortingOrder: [{
            type: core_1.Input
        }], allowedAggFuncs: [{
            type: core_1.Input
        }], menuTabs: [{
            type: core_1.Input
        }], cellClassRules: [{
            type: core_1.Input
        }], icons: [{
            type: core_1.Input
        }], headerGroupComponent: [{
            type: core_1.Input
        }], headerGroupComponentFramework: [{
            type: core_1.Input
        }], headerGroupComponentParams: [{
            type: core_1.Input
        }], cellStyle: [{
            type: core_1.Input
        }], cellRendererParams: [{
            type: core_1.Input
        }], cellEditorFramework: [{
            type: core_1.Input
        }], cellEditorParams: [{
            type: core_1.Input
        }], pinnedRowCellRendererFramework: [{
            type: core_1.Input
        }], pinnedRowCellRendererParams: [{
            type: core_1.Input
        }], filterFramework: [{
            type: core_1.Input
        }], filterParams: [{
            type: core_1.Input
        }], headerComponent: [{
            type: core_1.Input
        }], headerComponentFramework: [{
            type: core_1.Input
        }], headerComponentParams: [{
            type: core_1.Input
        }], floatingFilterComponent: [{
            type: core_1.Input
        }], floatingFilterComponentParams: [{
            type: core_1.Input
        }], floatingFilterComponentFramework: [{
            type: core_1.Input
        }], tooltipComponent: [{
            type: core_1.Input
        }], tooltipComponentParams: [{
            type: core_1.Input
        }], tooltipComponentFramework: [{
            type: core_1.Input
        }], refData: [{
            type: core_1.Input
        }], headerName: [{
            type: core_1.Input
        }], columnGroupShow: [{
            type: core_1.Input
        }], headerClass: [{
            type: core_1.Input
        }], toolPanelClass: [{
            type: core_1.Input
        }], headerValueGetter: [{
            type: core_1.Input
        }], groupId: [{
            type: core_1.Input
        }], colId: [{
            type: core_1.Input
        }], sort: [{
            type: core_1.Input
        }], field: [{
            type: core_1.Input
        }], type: [{
            type: core_1.Input
        }], tooltipField: [{
            type: core_1.Input
        }], headerTooltip: [{
            type: core_1.Input
        }], cellClass: [{
            type: core_1.Input
        }], showRowGroup: [{
            type: core_1.Input
        }], filter: [{
            type: core_1.Input
        }], aggFunc: [{
            type: core_1.Input
        }], cellRenderer: [{
            type: core_1.Input
        }], cellEditor: [{
            type: core_1.Input
        }], pinned: [{
            type: core_1.Input
        }], chartDataType: [{
            type: core_1.Input
        }], sortedAt: [{
            type: core_1.Input
        }], flex: [{
            type: core_1.Input
        }], width: [{
            type: core_1.Input
        }], minWidth: [{
            type: core_1.Input
        }], maxWidth: [{
            type: core_1.Input
        }], rowGroupIndex: [{
            type: core_1.Input
        }], pivotIndex: [{
            type: core_1.Input
        }], dndSourceOnRowDrag: [{
            type: core_1.Input
        }], valueGetter: [{
            type: core_1.Input
        }], valueSetter: [{
            type: core_1.Input
        }], filterValueGetter: [{
            type: core_1.Input
        }], keyCreator: [{
            type: core_1.Input
        }], cellRendererFramework: [{
            type: core_1.Input
        }], pinnedRowCellRenderer: [{
            type: core_1.Input
        }], valueFormatter: [{
            type: core_1.Input
        }], pinnedRowValueFormatter: [{
            type: core_1.Input
        }], valueParser: [{
            type: core_1.Input
        }], comparator: [{
            type: core_1.Input
        }], equals: [{
            type: core_1.Input
        }], pivotComparator: [{
            type: core_1.Input
        }], suppressKeyboardEvent: [{
            type: core_1.Input
        }], colSpan: [{
            type: core_1.Input
        }], rowSpan: [{
            type: core_1.Input
        }], getQuickFilterText: [{
            type: core_1.Input
        }], newValueHandler: [{
            type: core_1.Input
        }], onCellValueChanged: [{
            type: core_1.Input
        }], onCellClicked: [{
            type: core_1.Input
        }], onCellDoubleClicked: [{
            type: core_1.Input
        }], onCellContextMenu: [{
            type: core_1.Input
        }], tooltip: [{
            type: core_1.Input
        }], tooltipValueGetter: [{
            type: core_1.Input
        }], cellRendererSelector: [{
            type: core_1.Input
        }], cellEditorSelector: [{
            type: core_1.Input
        }], suppressCellFlash: [{
            type: core_1.Input
        }], suppressColumnsToolPanel: [{
            type: core_1.Input
        }], suppressFiltersToolPanel: [{
            type: core_1.Input
        }], openByDefault: [{
            type: core_1.Input
        }], marryChildren: [{
            type: core_1.Input
        }], hide: [{
            type: core_1.Input
        }], rowGroup: [{
            type: core_1.Input
        }], pivot: [{
            type: core_1.Input
        }], checkboxSelection: [{
            type: core_1.Input
        }], headerCheckboxSelection: [{
            type: core_1.Input
        }], headerCheckboxSelectionFilteredOnly: [{
            type: core_1.Input
        }], suppressMenu: [{
            type: core_1.Input
        }], suppressSorting: [{
            type: core_1.Input
        }], suppressMovable: [{
            type: core_1.Input
        }], suppressFilter: [{
            type: core_1.Input
        }], lockPosition: [{
            type: core_1.Input
        }], lockVisible: [{
            type: core_1.Input
        }], lockPinned: [{
            type: core_1.Input
        }], unSortIcon: [{
            type: core_1.Input
        }], suppressSizeToFit: [{
            type: core_1.Input
        }], suppressResize: [{
            type: core_1.Input
        }], suppressAutoSize: [{
            type: core_1.Input
        }], enableRowGroup: [{
            type: core_1.Input
        }], enablePivot: [{
            type: core_1.Input
        }], enableValue: [{
            type: core_1.Input
        }], editable: [{
            type: core_1.Input
        }], suppressPaste: [{
            type: core_1.Input
        }], suppressNavigable: [{
            type: core_1.Input
        }], enableCellChangeFlash: [{
            type: core_1.Input
        }], rowDrag: [{
            type: core_1.Input
        }], dndSource: [{
            type: core_1.Input
        }], autoHeight: [{
            type: core_1.Input
        }], sortable: [{
            type: core_1.Input
        }], resizable: [{
            type: core_1.Input
        }], singleClickEdit: [{
            type: core_1.Input
        }] }); })();
    return AgGridColumn;
}());
exports.AgGridColumn = AgGridColumn;

//# sourceMappingURL=agGridColumn.js.map